export default "__VITE_ASSET__pds_mLfY__"